import { useQuery } from "@apollo/client";
import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import * as React from "react";
import { AutopilotStatusTrialExpired } from "./AutopilotStatusTrialExpired";

import {
  AutopilotStatusTrialExpiredRendererDocument,
  AutopilotStatusTrialExpiredRendererQuery,
} from "./__generated__/AutopilotStatusTrialExpiredRenderer.generated";

interface IProps {
  openPricingDialog: (open: boolean) => void;
  orgId: string;
  orgTimeZone: string;
}
export const AutopilotStatusTrialExpiredRenderer = ({
  openPricingDialog,
  orgId,
  orgTimeZone,
}: IProps) => {
  const { data } = useQuery(AutopilotStatusTrialExpiredRendererDocument, {
    variables: { orgRelayId: orgId, timeZone: orgTimeZone },
  });

  const getNumMeetingsFromData = (queryData: AutopilotStatusTrialExpiredRendererQuery) => {
    if (queryData?.node) {
      const apEventResponse = getValue(queryData.node, "Org")?.autopilotEventsResponse;
      const enabledOrganized = apEventResponse
        ? getValue(apEventResponse, "AutopilotEventsResponse")
        : null;

      return enabledOrganized?.enabledOrganized?.length || 0;
    }
    return 0;
  };

  if (!!data) {
    return (
      <AutopilotStatusTrialExpired
        openPricingDialog={openPricingDialog}
        numEvents={getNumMeetingsFromData(data) || 0}
      />
    );
  } else {
    return null;
  }
};
